import script from "./myAds.vue?vue&type=script&setup=true&lang=js"
export * from "./myAds.vue?vue&type=script&setup=true&lang=js"

import "./myAds.vue?vue&type=style&index=0&id=18fa51de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18fa51de"]])

export default __exports__